// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__VFCDG","disabled":"Switch_disabled__lIl1p","slider":"Switch_slider__MTmJd"};